import { Platform } from '@ionic/angular';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IonApp, IonRouterOutlet, IonToast } from '@ionic/angular/standalone';
import { BackInterceptorService } from '@services/back-interceptor.service';
import { ToastService } from '@services/toast.service';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    imports: [IonApp, IonRouterOutlet, IonToast],
    changeDetection:ChangeDetectionStrategy.OnPush
})
export class AppComponent {

    private platform = inject(Platform);
    private backInterceptor = inject(BackInterceptorService);
    private toastService = inject(ToastService);

    protected readonly toastState = this.toastService.state;

    constructor() {
        this.platform.ready().then(() => this.backInterceptor.init());
    }

    protected dismissToast(): void {
        this.toastService.dismiss();
    }
}
